import { Tooltip } from "antd";
import React, { cloneElement, useRef, useState, useCallback, ReactElement, MouseEvent } from "react";

interface BaseTooltipProps {
  title: string;
  children: ReactElement<any>;
}

const BaseTooltip: React.FC<BaseTooltipProps> = ({ title, children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = useCallback(
    (e: MouseEvent) => {
      const el = ref.current;
      if (!el) return;
      const isOverflowing = el.scrollWidth > el.clientWidth;
      setShowTooltip(isOverflowing);

      if (children.props.onMouseEnter) {
        children.props.onMouseEnter(e);
      }
    },
    [children]
  );

  const isDomElement = typeof children.type === "string";

  const propsToInject = {
    ...(isDomElement ? { ref } : {}),
    onMouseEnter: handleMouseEnter
  };

  const clonedChild = cloneElement(children, propsToInject);

  return showTooltip ? (
    <Tooltip
      title={title}
      color="white"
      arrow={false}
      overlayInnerStyle={{
        color: "#404040",
        border: "1px solid #E5E5E5",
        padding: "8px 12px",
        lineHeight: "20px",
        borderRadius: "8px",
        boxShadow: "0 8px 8px -4px rgba(16, 24, 40, 0.03), 0 20px 24px -4px rgba(16, 24, 40, 0.08)"
      }}
    >
      {clonedChild}
    </Tooltip>
  ) : (
    clonedChild
  );
};

export default BaseTooltip;
